import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { TabList, Tab, TabText, MenuItem } from '@tq/ui-components';

import { MobileMoreTab } from '../MobileMoreTab';

export interface MobileTabListProps {
  activeTabIndex: number;
  tabLabels: string[];
  onChangeActiveTab: (index: number) => void;
}
export const MobileTabList: React.FC<MobileTabListProps> = ({
  activeTabIndex,
  tabLabels,
  onChangeActiveTab,
}) => {
  return (
    <TabList color={COLOURS.blue[600]} maxWidth='unset' pb={0}>
      <Tab color={COLOURS.blue[600]} onClick={() => onChangeActiveTab(0)}>
        <TabText fontSize='md'>{tabLabels[0]}</TabText>
      </Tab>
      <Tab onClick={() => onChangeActiveTab(1)}>
        <TabText fontSize='md'>{tabLabels[1]}</TabText>
      </Tab>
      {tabLabels.length > 2 && (
        <MobileMoreTab isActive={activeTabIndex > 1}>
          {tabLabels.slice(2).map((label, index) => (
            <MenuItem
              key={label}
              onClick={() => onChangeActiveTab(index + 2)}
              sx={{
                bgColor: activeTabIndex === index + 2 ? COLOURS.blue[900] : undefined,
                color: activeTabIndex === index + 2 ? COLOURS.white : undefined,
                '&:focus': {
                  bgColor: 'neutral.4',
                },
              }}
            >
              {label}
            </MenuItem>
          ))}
        </MobileMoreTab>
      )}
    </TabList>
  );
};
